import { BranchCategoryCreatePage } from '@/features/branch-category/pages/BranchCategoryCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/branch-category/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch_category.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchCategoryCreatePage,
})
